import { setupDialogListener } from "./dialog/dialog-listener";
import EventBus from "./event-bus";

type EventHandler = (target: HTMLElement, event: Event) => void;

const delegatedHandler = (eventType: string, handler: EventHandler) => {
  return (event: Event) => {
    const { target } = event;

    if (target && event.type === eventType) {
      const actionElement = (target as HTMLElement).closest("[data-action]");

      handler((actionElement || target) as HTMLElement, event);
    }
  };
};

const clickHandler = delegatedHandler("click", (target, event) => {
  if (target.dataset.action) {
    handleDataAction(target, event);
  }
});

const handleDataAction = (target: HTMLElement, event: Event) => {
  const data = { ...target.dataset, event } as any;

  eventBus.emit(data.action, data);
};

const eventBus = new EventBus();

document.addEventListener("click", clickHandler, { passive: false });
window.addEventListener("beforeunload", clickHandler, { once: true });

setupDialogListener(eventBus);
